module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-2",
    attrs: {
      "width": "100%"
    }
  }, [_c('v-card-title', [_c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("New Customer")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.formTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": "",
      "disabled": !_vm.newCustomerValid
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "newCustomer",
    model: {
      value: (_vm.newCustomerValid),
      callback: function($$v) {
        _vm.newCustomerValid = $$v
      },
      expression: "newCustomerValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Customer Name",
      "rules": [function (v) { return !!v || 'Name is required'; }],
      "required": ""
    },
    model: {
      value: (_vm.editedItem.customerName),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "customerName", $$v)
      },
      expression: "editedItem.customerName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editedIndex < 0),
      expression: "editedIndex < 0"
    }],
    attrs: {
      "label": "Short Name",
      "rules": [function (v) { return !!v || 'Short Name is required'; }],
      "required": "",
      "hint": "This is used as a prefix for project and job numbers"
    },
    model: {
      value: (_vm.editedItem.shortName),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "shortName", $$v)
      },
      expression: "editedItem.shortName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Customer No.",
      "hint": "Customer Number Normally first 3 letters of name followed by 3 numbers"
    },
    model: {
      value: (_vm.editedItem.customerNumber),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "customerNumber", $$v)
      },
      expression: "editedItem.customerNumber"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Select BDM User",
      "items": _vm.bdmUsers,
      "item-text": "Name",
      "return-object": "",
      "clearable": ""
    },
    model: {
      value: (_vm.BDMSelect),
      callback: function($$v) {
        _vm.BDMSelect = $$v
      },
      expression: "BDMSelect"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "BDM Name"
    },
    model: {
      value: (_vm.editedItem.BDM),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "BDM", $$v)
      },
      expression: "editedItem.BDM"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "email",
      "label": "BDM Email"
    },
    model: {
      value: (_vm.editedItem.BDMEmail),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "BDMEmail", $$v)
      },
      expression: "editedItem.BDMEmail"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Select Desk Manager User",
      "items": _vm.dbamUsers,
      "item-text": "Name",
      "return-object": "",
      "clearable": ""
    },
    model: {
      value: (_vm.DMSelect),
      callback: function($$v) {
        _vm.DMSelect = $$v
      },
      expression: "DMSelect"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Desk Manager Name"
    },
    model: {
      value: (_vm.editedItem.DeskManager),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "DeskManager", $$v)
      },
      expression: "editedItem.DeskManager"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "email",
      "label": "Desk Manager Email"
    },
    model: {
      value: (_vm.editedItem.DeskManagerEmail),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "DeskManagerEmail", $$v)
      },
      expression: "editedItem.DeskManagerEmail"
    }
  })], 1), _vm._v(" "), _c('v-list', [_c('v-subheader', [_vm._v("Sites\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.editedItem.id === undefined,
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.selectedSiteKey = null;
        _vm.siteDialog = true
      }
    }
  }, [_vm._v("Add Site"), _c('v-icon', [_vm._v("add_location")])], 1)], 1), _vm._v(" "), _vm._l((_vm.sites), function(site) {
    return _c('v-list-tile', {
      key: site.id,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedSiteKey = site.id;
          _vm.siteDialog = true
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("place")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(site.Name)
      }
    })], 1)], 1)
  })], 2)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.customers,
      "search": _vm.search,
      "item-key": "id",
      "loading": _vm.tableLoading,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.editItem(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.customerName))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.editItem(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.customerNumber || ''))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteItem(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('site-edit-dialog', {
    attrs: {
      "customer": _vm.editedItem,
      "customers": _vm.customerObj,
      "siteDialog": _vm.siteDialog,
      "siteID": _vm.selectedSiteKey
    },
    on: {
      "getSites": _vm.refreshSites,
      "setCustomer": _vm.updateCustomer,
      "update:siteDialog": function($event) {
        _vm.siteDialog = $event
      },
      "update:site-dialog": function($event) {
        _vm.siteDialog = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cef364a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Customer.vue
// module id = 760
// module chunks = 1